// Pixel PFP at an integer-ish scale with crisp pixels.
import { useEffect, useRef } from "preact/hooks";
import { pfpCanvas } from "../pfp/canvas";
import { PFP_SIZE } from "../pfp/generator";

export function PfpImage({ seed, traits, size = 64, class: cls = "" }: { seed: number; traits: Record<string, string>; size?: number; class?: string }) {
  const ref = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const ctx = ref.current!.getContext("2d")!;
    ctx.drawImage(pfpCanvas(seed, traits), 0, 0);
  }, [seed]);
  return <canvas ref={ref} width={PFP_SIZE} height={PFP_SIZE} class={`pfp ${cls}`} style={{ width: `${size}px`, height: `${size}px` }} />;
}
